import React, { Component } from "react";
import styled, { css } from "styled-components";
import { translate } from "react-i18next";

class MenuItem extends Component {
  constructor() {
    super();
    this.state = {
      expanded: false,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener("click", this.handleClick);
  }
  componentWillUnmount() {
    document.removeEventListener("click", this.handleClick);
  }

  handleClick(e) {
    if (!this.menuItem.contains(e.target)) {
      if (document.getElementsByClassName("navigation_menu")[0].contains(e.target)) {
        this.setState({ expanded: false });
      }
    }
  }

  makeMenu(items) {
    const { history, navigationMenu } = this.props;
    const menu = [];
    items.forEach((item) => {
      menu.push(<MenuItem navigationMenu={navigationMenu} history={history} item={item} />);
    });
    return menu;
  }

  nestedActive = (items) => {
    let nestedActive = false;
    items.forEach((item) => {
      if (window.location.pathname.includes(item.route)) {
        nestedActive = true;
      }
    });
    return nestedActive;
  };

  render() {
    const {
      name, items, rightIcon, route,
    } = this.props.item;
    const { expanded } = this.state;
    const {
      onClick, root, history, style, t,
    } = this.props;
    const active = window.location.pathname.includes(route) || this.nestedActive(items || []);
    return (
      <MenuItemView
        onClick={onClick}
        root={root}
        innerRef={(menuItem) => {
          this.menuItem = menuItem;
        }}
        style={style}
      >
        <MenuItemWrapper
          onClick={() => {
            if (route) {
              history.push(route);
            } else {
              this.setState({ expanded: !expanded });
            }
          }}
        >
          {rightIcon && (
            <IconWrapper>
              {React.cloneElement(rightIcon, {
                style: { color: active ? "#732a50" : "rgba(0,0,0,0.4)" },
              })}
            </IconWrapper>
          )}
          <MenuItemName active={active} root={root}>
            {t(name)}
          </MenuItemName>
        </MenuItemWrapper>
        {items && (
          <NestedItems style={{ height: expanded && items ? `${50 * items.length}px` : "0px" }}>
            {this.makeMenu(items)}
          </NestedItems>
        )}
      </MenuItemView>
    );
  }
}

export default translate()(MenuItem);

const NestedItems = styled.div`
  overflow: auto;
  transition: all 0.3s;
`;

const MenuItemWrapper = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
`;

const MenuItemView = styled.div`
  cursor: pointer;
  padding-left: 20px;
  ${({ root }) =>
    root &&
    css`
      border-style: solid;
      border-width: 0 0 1px 0;
      border-color: #eee;
    `};
`;

const IconWrapper = styled.div`
  margin-left: -10px;
  margin-right: 10px;
  color: rgba(0, 0, 0, 0.4);
`;

const MenuItemName = styled.span`
  font-size: 11pt;
  color: ${({ active }) => (active ? "#732a50" : "rgba(0, 0, 0, 0.4)")};
  ${({ root }) =>
    root &&
    css`
      font-weight: 500;
      text-transform: uppercase;
    `};
`;



// WEBPACK FOOTER //
// ./src/components/MenuItem.js